<app-screen-content [isLoading]="model.isLoading" class="accredited-investor">
  <div title *ngIf="globals.isMobile">
    <app-section-header>Accredited Investor</app-section-header>
  </div>
  <div body>
    <form [formGroup]="form" (ngSubmit)="model.onSubmit()">
      <div class="box static-content">
        <div class="section-title">Eligibility requirements</div>
        <div>
          Your organisation must meet the following requirements to be qualified
          as an Accredited Investor
        </div>
        <div class="box box-white">
          <div class="section-title">Corporations</div>
          <ul>
            <li>
              Net assets* exceed S$10 million (or its equivalent in a foreign
              currency); or
            </li>
            <li>
              Entire share capital of which is owned by one or more persons,
              each of whom is an accredited investor
            </li>
          </ul>
          <div class="section-title">Entity (other than a corporation)</div>
          <ul>
            <li>
              Net assets* exceed S$10 million (or its equivalent in a foreign
              currency)
            </li>
          </ul>
          <div class="section-title">
            Partnership (other than limited liability partnership)
          </div>
          <ul>
            <li>
              Net assets* exceed S$10 million (or its equivalent in a foreign
              currency)
            </li>
          </ul>
          <div class="section-title">
            Trustee of Trust, when acting in that capacity where
          </div>
          <ul>
            <li>
              Trust property exceeds S$10 million in value (or its equivalent in
              a foreign currency); or
            </li>
            <li>All beneficiaries of the trust are accredited investors; or</li>
            <li>
              All settlors are accredited investors and have settlor reserved
              investment powers and revocation powers
            </li>
          </ul>
          <div class="definition">
            <div><b>Net Assets</b> as determined by:</div>
            <div>
              (i) the most recent audited balance-sheet of the corporation; or
            </div>
            <div>
              (ii) where the corporation is not required to prepare audited
              accounts regularly, a balance-sheet of the corporation certified
              by the corporation as giving a true and fair view of the state of
              affairs of the corporation as of the date of the balance-sheet,
              which shall be a date within the preceding 12 month.
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="question-title">
          Does your organisation qualify as an Accredited Investor?
        </div>
        <div class="row">
          <div class="col-lg-6 qualified-radio-btn">
            <app-radio
              label="Yes"
              description="We qualify as an Accredited Investor"
              [radioValue]="true"
              [value]="isQualifiedAccreditedInvestorControl.value"
              name="isQualifiedAccreditedInvestor"
              formControlName="isQualifiedAccreditedInvestor"
            ></app-radio>
          </div>
          <div class="col-lg-6 qualified-radio-btn">
            <app-radio
              label="No"
              description="We do not meet the eligibility requirements"
              [radioValue]="false"
              [value]="isQualifiedAccreditedInvestorControl.value"
              name="isQualifiedAccreditedInvestor"
              formControlName="isQualifiedAccreditedInvestor"
            ></app-radio>
          </div>
        </div>
        <!-- Showing error method -->
        <div
          *ngIf="
            model.shouldShowErrors &&
            isQualifiedAccreditedInvestorControl.errors?.required
          "
          class="error fna-mt-10"
        >
          Please select an option
        </div>
      </div>
      <div class="bottom-nav">
        <app-back-button (click)="goToPreviousScreen()"></app-back-button>
        <app-next-button buttonType="submit"></app-next-button>
      </div>
    </form>
  </div>

  <div *ngIf="globals.isDebug">
    <h3>Information for developers, please ignore</h3>
    <h4>Data</h4>
    <pre class="debug-log-mono">{{ model.data | json }}</pre>
    <h4>Model</h4>
    <h5>Form value</h5>
    <pre class="debug-log-mono">{{ form.value | json }}</pre>
  </div>
</app-screen-content>

<ng-template #modalTermsAndConditions let-modal>
  <div class="modal-header scroll-shadow-top">
    <div class="modal-title" ngbAutoFocus>
      {{ model.termsAndConditions?.title }}
    </div>
  </div>
  <div class="modal-body modal-content-padding managed-content">
    <div
      class="digital-fna-tnc"
      [innerHTML]="model.termsAndConditions?.body"
    ></div>
  </div>

  <!--  <div class="modal-body modal-content-padding managed-content">-->
  <!--    <div class="digital-fna-tnc">-->
  <!--      <p>-->
  <!--        These terms and conditions (&ldquo;Terms and Conditions&rdquo;) shall-->
  <!--        apply to the online application as an accredited investor (&ldquo;AI-->
  <!--        Request&rdquo;) and the online completion and submission of a digital-->
  <!--        version of the Financial Needs Analysis Form (Non-Individual) which is-->
  <!--        signed using a digital signature (&ldquo;Digital FNA&rdquo;), by an-->
  <!--        authorised person acting for and on behalf of an organisation, where-->
  <!--        that organisation is an existing customer with Oversea-Chinese Banking-->
  <!--        Corporation Limited (&ldquo;OCBC Bank&rdquo;).-->
  <!--      </p>-->
  <!--      <ol>-->
  <!--        <li>-->
  <!--          General-->
  <!--          <ol>-->
  <!--            <li>-->
  <!--              In these Terms and Conditions, references to "us" and "we" means-->
  <!--              OCBC Bank. The term "customer" and "client" and "you" and "your"-->
  <!--              means any authorised person acting for and on behalf of an-->
  <!--              organisation, where that organisation is an existing customer with-->
  <!--              OCBC Bank, who is applying, completing, digitally signing and/or-->
  <!--              submitting the AI Request or the Digital FNA (as the case may be)-->
  <!--              online to us.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              For the purposes of these Terms and Conditions, you agree, warrant-->
  <!--              and undertake that you are duly authorised to act for and on-->
  <!--              behalf of the organisation in relation to the online application-->
  <!--              of the AI Request or the completion and/or submission of the-->
  <!--              Digital FNA, where that organisation is an existing customer with-->
  <!--              OCBC Bank (&ldquo;the Organisation&rdquo;). You also agree,-->
  <!--              warrant and undertake that in the course of providing information,-->
  <!--              applying as an accredited investor or completing, digitally-->
  <!--              signing and/or submitting the Digital FNA online to us that you-->
  <!--              are doing so in your capacity as an authorised person for and on-->
  <!--              behalf of the Organisation (&ldquo;Authorised Person&rdquo;).-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              Your access in your capacity as an Authorised Person to the OCBC-->
  <!--              AI Request and Digital FNA platform (referred to as the-->
  <!--              &ldquo;Platform&rdquo;) which we currently host and operate-->
  <!--              through our website (gtclientforms.ocbc.com) is subject to these-->
  <!--              Terms and Conditions, as well as to disclaimers [and any other-->
  <!--              applicable Terms and Conditions], which are incorporated herein by-->
  <!--              reference (collectively referred to as the &ldquo;Terms and-->
  <!--              Conditions&rdquo;), as they may be amended from time to time, and-->
  <!--              all applicable laws.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              These Terms and Conditions contain important information regarding-->
  <!--              the Services (as defined at Clause 6.2) that we will provide to-->
  <!--              you and your obligations and responsibilities in your capacity as-->
  <!--              an Authorised Person acting for and on behalf of the Organisation-->
  <!--              in relation to the online application of the AI Request or the-->
  <!--              completion and/or submission of the Digital FNA. These Terms and-->
  <!--              Conditions are for your own protection and you should read them-->
  <!--              carefully before accepting them. If you do not understand anything-->
  <!--              in these Terms and Conditions, please contact your assigned-->
  <!--              Corporate Sales and Structurer and ask for further information.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              In your capacity as an Authorised Person acting for and on behalf-->
  <!--              of the Organisation, where that Organisation is an existing-->
  <!--              customer of OCBC Bank and which has already been on-boarded, we-->
  <!--              will send you an e-mail containing an invitation-only link to-->
  <!--              access, apply as an accredited investor or to complete, digitally-->
  <!--              sign and submit the Digital FNA online to us. As an Authorised-->
  <!--              Person, you will use the link provided to access the Platform to-->
  <!--              apply as an accredited investor or to complete, digitally sign-->
  <!--              and/or submit the Digital FNA for and on behalf of the-->
  <!--              Organisation. To access the AI Request or the Digital FNA online-->
  <!--              and use the Platform, you will be required to log-in using-->
  <!--              multi-factor authentication, including but not limited to:-->
  <!--              <ol>-->
  <!--                <li>-->
  <!--                  OCBC Velocity, as the Digital Business Banking platform to-->
  <!--                  help our corporate customers to manage day to day business-->
  <!--                  banking needs from making and approving transactions,-->
  <!--                  collecting payments, reviewing cash flow reports as well as-->
  <!--                  managing trade portfolio online safely and securely;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  CorpPass identification and access information, as the-->
  <!--                  corporate access authorisation system provided by the-->
  <!--                  Government of Singapore to enable entities to manage digital-->
  <!--                  service access of employees to perform corporate transactions-->
  <!--                  on behalf of the Organisation; and/or-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  emails from us, including those containing access links to-->
  <!--                  access the Platform, together with a one-time email password-->
  <!--                  and/or a one-time SMS password;-->
  <!--                  <p>-->
  <!--                    (collectively referred to as &ldquo;Multi-Factor-->
  <!--                    Authentication&rdquo;),-->
  <!--                  </p>-->
  <!--                </li>-->
  <!--              </ol>-->
  <!--            </li>-->
  <!--            <p>-->
  <!--              (In the case of the Digital FNA), you will digitally sign the-->
  <!--              Digital FNA using a digital signature in your capacity as an-->
  <!--              Authorised Person acting for and on behalf of the Organisation,-->
  <!--              before submitting the Digital FNA online to us.-->
  <!--            </p>-->
  <!--            <li>-->
  <!--              Your e-mail address, and any other contact information you provide-->
  <!--              in your capacity as an Authorised Person to act for and on behalf-->
  <!--              of the Organisation, form your user registered information to-->
  <!--              access the Platform. When you provide this information to register-->
  <!--              for and/or to access the Platform, you agree, undertake and-->
  <!--              warrant that you are responsible for maintaining the-->
  <!--              confidentiality of all emails from us in relation to the AI-->
  <!--              Request or the Digital FNA, including any access links contained-->
  <!--              therein, all information in relation to Multi-Factor-->
  <!--              Authentication, including one-time passwords howsoever provided,-->
  <!--              which, along with your e-mail address, allows you to access the-->
  <!--              Platform in your capacity as an Authorised Person. Without-->
  <!--              prejudice to any other terms and conditions, such access to the-->
  <!--              Platform is provided &lsquo;as-is&rsquo; for your convenience.-->
  <!--              Accordingly, we shall not be liable to you for any loss, damages-->
  <!--              or expenses (including any direct, indirect, incidental, special,-->
  <!--              consequential or punitive damages or economic loss or any claims-->
  <!--              for loss of profits or loss of use) whatsoever or howsoever caused-->
  <!--              (regardless of the form of action) arising directly or indirectly-->
  <!--              in connection with any access, use and/or inabilitytoaccess the-->
  <!--              Platform and/or to apply as an accredited investor or to complete-->
  <!--              and submit the Digital FNA to us.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              By providing us with your e-mail address in your capacity as an-->
  <!--              Authorised Person acting for and on behalf of the Organisation in-->
  <!--              relation to the AI Request or the Digital FNA, you agree to-->
  <!--              receive all required notices in relation to the AI Request of the-->
  <!--              Digital FNA electronically, to that e-mail address. It is your-->
  <!--              responsibility to update or change that e-mail address, as-->
  <!--              appropriate. If you become aware of any unauthorised use of your-->
  <!--              e-mail address and/or any of the information we have sent to you-->
  <!--              for the purposes of accessing, applying as an accredited investor-->
  <!--              or completing, digitally signing and/or submitting the Digital-->
  <!--              FNA, please immediately contact your assigned Corporate Sales and-->
  <!--              Structurer.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              By accessing or using the Platform in any way, you agree to comply-->
  <!--              with these Terms and Conditions and all applicable laws, rules and-->
  <!--              regulations and any restrictions defined in the Terms and-->
  <!--              Conditions and other applicable agreements, disclosures, and-->
  <!--              documents. You agree that you will:-->
  <!--              <ol>-->
  <!--                <li>-->
  <!--                  ensure at all times that all information relating to the AI-->
  <!--                  Request and the Digital FNA, including but not limited to all-->
  <!--                  emails from us in relation to the AI Request and the Digital-->
  <!--                  FNA, all access links, all information relating to-->
  <!--                  Multi-Factor Authentication, and all one-time passwords-->
  <!--                  howsoever provided, is confidential, and that all necessary-->
  <!--                  measures and/or safeguards are in place to maintain the-->
  <!--                  confidentiality of this information at all times;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  ensure that you, in your capacity as an Authorised Person, are-->
  <!--                  the only person with access to information relating to the AI-->
  <!--                  Request and the Digital FNA, including but not limited to all-->
  <!--                  emails from us in relation to the AI Request and the Digital-->
  <!--                  FNA, all access links, all information relating to-->
  <!--                  Multi-Factor Authentication, and all one-time passwords-->
  <!--                  howsoever provided;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  (in the case of the Digital FNA), sign the Digital FNA using a-->
  <!--                  digital signature, which is an electronic signature consisting-->
  <!--                  of an electronic record using an asymmetric cryptosystem and a-->
  <!--                  hash function, such that the digital signature will be treated-->
  <!--                  as a secure electronic signature within the meaning of the-->
  <!--                  Electronic Transactions Act (Cap. 88). You also agree and-->
  <!--                  undertake to complete, digitally sign and/or submit the-->
  <!--                  Digital FNA to us entirely online and through electronic-->
  <!--                  means, and you further agree and undertake not to print out,-->
  <!--                  produce or otherwise make a physical copy of the Digital FNA-->
  <!--                  so as to purport to invalidate the digital signature used to-->
  <!--                  digitally sign the Digital FNA;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  (in the case of the Digital FNA), be appropriately authorised-->
  <!--                  in your capacity as an Authorised Person to complete,-->
  <!--                  digitally sign and submit the Digital FNA for and on behalf of-->
  <!--                  the Organisation, and that the digital signature you use to-->
  <!--                  sign the Digital FNA in your capacity as an Authorised Person-->
  <!--                  is legally binding and is so in the same way and to the same-->
  <!--                  extent that a signature on a hard copy version of the document-->
  <!--                  would otherwise be; and-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  complete and submit information in the AI Request or the-->
  <!--                  Digital FNA and/or via the Platform in your capacity as an-->
  <!--                  Authorised Person acting for and on behalf of the Organisation-->
  <!--                  that is accurate, true and correct,-->
  <!--                </li>-->
  <!--              </ol>-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You agree that you will not, and will not permit anyone else to:-->
  <!--              <ol>-->
  <!--                <li>-->
  <!--                  access and/or share any of the information relating to the-->
  <!--                  Platform, the AI Request and/or the Digital FNA for which you-->
  <!--                  are the intended recipient in your capacity as an Authorised-->
  <!--                  Person, including but not limited to all emails from us in-->
  <!--                  relation to the AI Request or Digital FNA, all access links,-->
  <!--                  all information relating to Multi-Factor Authentication, and-->
  <!--                  all one-time passwords howsoever provided;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  store, copy, modify, or resell any of the information-->
  <!--                  available on the Platform or compile or collect any such-->
  <!--                  information as part of a database or other work, or use any-->
  <!--                  automated tool (e.g., robots and/or spiders) to use the-->
  <!--                  website or store, copy, modify, distribute, or resell any such-->
  <!--                  information;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  use, copy or otherwise exploit the website or any related-->
  <!--                  concepts, content or information available on the Platform for-->
  <!--                  any purpose except in accordance with these Terms and-->
  <!--                  Conditions;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  circumvent or disable any digital rights management, usage-->
  <!--                  rules, or other security features of the Platform, and/or use-->
  <!--                  the website in a manner that threatens its integrity,-->
  <!--                  performance, or availability; and/or-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  remove, alter, or obscure any proprietary notices (including-->
  <!--                  copyright notices) on any portion of the website or-->
  <!--                  information available on the Platform.-->
  <!--                </li>-->
  <!--              </ol>-->
  <!--            </li>-->
  <!--          </ol>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          Platform Usage-->
  <!--          <ol>-->
  <!--            <li>-->
  <!--              You agree you will:-->
  <!--              <ol>-->
  <!--                <li>-->
  <!--                  comply with all applicable laws, including, without-->
  <!--                  limitation, privacy laws, intellectual property laws,-->
  <!--                  anti-spam laws, export control laws, tax laws, and all-->
  <!--                  regulatory requirements;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  provide accurate information to us, whether reported directly-->
  <!--                  or through a third party whom you authorise, and keep it-->
  <!--                  updated;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  use the Services (as defined at Clause 6.2) of the Platform-->
  <!--                  solely in your capacity as an Authorised Person acting for and-->
  <!--                  on behalf of the Organisation;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  use your real name on your profile as per OCBC Bank record in-->
  <!--                  your capacity as an Authorised Person acting for and on behalf-->
  <!--                  of the Organisation; and-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  keep all information relating to the AI Request or the Digital-->
  <!--                  FNA, including but not limited to all log-in credentials,-->
  <!--                  passwords, emails from us in relation to the AI Request or the-->
  <!--                  Digital FNA, all access links, all information relating to-->
  <!--                  Multi-Factor Authentication, and all one-time passwords-->
  <!--                  howsoever provided, confidential at all times.-->
  <!--                </li>-->
  <!--              </ol>-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You agree you will not:-->
  <!--              <ol>-->
  <!--                <li>-->
  <!--                  circumvent, disable, or otherwise interfere with-->
  <!--                  security-related features of the Platform and/or the website,-->
  <!--                  or features that prevent or restrict use or copying of any-->
  <!--                  content or user information;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  upload, e-mail, transmit, provide, or otherwise make-->
  <!--                  available:-->
  <!--                  <ol>-->
  <!--                    <li>-->
  <!--                      any user information which you do not have the lawful-->
  <!--                      right to use, copy, transmit, display, or make available-->
  <!--                      (including any user information that would violate any-->
  <!--                      confidentiality or fiduciary obligations that you might-->
  <!--                      have with respect to the user information);-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      any user information that infringes the intellectual-->
  <!--                      property rights of, or violates the privacy rights of, any-->
  <!--                      third-party (including without limitation copyright,-->
  <!--                      trademark, patent, trade secret, or other intellectual-->
  <!--                      property right, moral right, or right of publicity); or-->
  <!--                      unsolicited or unauthorised advertising, promotional-->
  <!--                      materials, junk mail, spam, chain letters, pyramid-->
  <!--                      schemes, or any other form of solicitation;-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      any information that is unlawful, obscene, harmful,-->
  <!--                      threatening, harassing, defamatory, or hateful, or that-->
  <!--                      contain objects or symbols of hate, invade the privacy of-->
  <!--                      any third-party, contain nudity, are deceptive,-->
  <!--                      threatening, abusive, inciting of unlawful action, or are-->
  <!--                      otherwise objectionable in our sole discretion;-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      any information that contains software viruses or any-->
  <!--                      other computer code, files, or programs designed to (i)-->
  <!--                      interrupt, destroy, or limit the functionality of any-->
  <!--                      computer software; or (ii) interfere with the access of-->
  <!--                      any user, host or network, including without limitation-->
  <!--                      overloading, flooding, spamming, mail-bombing, or sending-->
  <!--                      a virus to the Platform; and/or-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      any information that includes code that is hidden or-->
  <!--                      otherwise surreptitiously contained within the user-->
  <!--                      information-->
  <!--                    </li>-->
  <!--                  </ol>-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  use any meta tags or other hidden text or metadata utilising-->
  <!--                  our trademark, URL or product name;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  forge any TCP/IP packet header or any part of the header-->
  <!--                  information in any posting, or in any way use the platform to-->
  <!--                  send altered, deceptive, or false source- identifying-->
  <!--                  information;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  interfere with or disrupt (or attempt to interfere with or-->
  <!--                  disrupt) any the Platform, website, server, and/or network, or-->
  <!--                  the technical delivery systems of the Platform, or disobey any-->
  <!--                  requirements, procedures, policies, or regulations of networks-->
  <!--                  connected to the Platform and/or website;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  attempt to probe, scan, or test the vulnerability of the-->
  <!--                  Platform system and/or network or breach or impair or-->
  <!--                  circumvent any security or authentication measures protecting-->
  <!--                  the Platform;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  attempt to decipher, decompile, disassemble, or-->
  <!--                  reverse-engineer any of the software used to operate the-->
  <!--                  Platform and/or website;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  attempt to access, search, or meta-search the Platform or-->
  <!--                  content thereon with any engine, software, tool, agent,-->
  <!--                  device, or mechanism other than software and/or search agents-->
  <!--                  provided by the Platform or other generally available-->
  <!--                  third-party web browsers, including without limitation any-->
  <!--                  software that sends queries to the Platform to determine how a-->
  <!--                  website or web page ranks;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  violate the terms of service or any other rule or agreement-->
  <!--                  applicable to you or the Platform&rsquo;s inclusion in,-->
  <!--                  reference to, or relationship with any third party or-->
  <!--                  third-party site or service, or your use of any such-->
  <!--                  third-party site or service;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  collect or store personal information about other users-->
  <!--                  without their express permission;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  impersonate or misrepresent your capacity as an Authorised-->
  <!--                  Person acting for and on behalf of the Organisation or your-->
  <!--                  affiliation with any person or entity, through pretexting or-->
  <!--                  some other form of social engineering, or commit fraud;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  solicit any user for any commercial or promotional-->
  <!--                  transaction;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  violate any applicable law, regulation, and/or ordinance;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  scrape or copy information through any means (including-->
  <!--                  crawlers, browser plugins and add-ons, and any other-->
  <!--                  technology or manual work);-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  use, launch, or permit to be used any automated system,-->
  <!--                  including without limitation robots, crawlers and/or spiders;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  monitor the Platform&rsquo;s availability, performance or-->
  <!--                  functionality for any competitive purposes; and/or-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  access and/or use the Platform or content thereon in any-->
  <!--                  manner not permitted by these Terms and Conditions.-->
  <!--                </li>-->
  <!--              </ol>-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              If you become aware of misuse of the Platform or content thereon-->
  <!--              by any person or entity, you shall immediately contact your-->
  <!--              assigned Corporate Sales and Structurer to report any abuse.-->
  <!--            </li>-->
  <!--          </ol>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          Communications-->
  <!--          <ol>-->
  <!--            <li>-->
  <!--              We will provide customer service support to you for matters-->
  <!--              relating to the Platform, the AI Request and the Digital FNA. This-->
  <!--              support is provided from your assigned Corporate Sales and-->
  <!--              Structurer.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              We will send all notices, information and other correspondence to-->
  <!--              you at the e-mail address provided by you in your capacity as an-->
  <!--              Authorised Person acting for and on behalf of the Organisation in-->
  <!--              relation to the AI Request or the Digital FNA. All such notices-->
  <!--              shall be deemed to have been received by you for and on behalf of-->
  <!--              the Organisation for which you are an Authorised Person-->
  <!--              immediately upon an e-mail being sent by us to the e-mail address-->
  <!--              provided by you, or immediately upon the message being sent by us-->
  <!--              to you through the website and/or the Platform.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              We cannot guarantee that electronic communications will be-->
  <!--              successfully delivered, or that they will be secure and virus-->
  <!--              free. We will not be liable for any loss, damage, expense, harm or-->
  <!--              inconvenience caused as a result of an e-mail being lost, delayed,-->
  <!--              intercepted, corrupted or otherwise altered or for failing to be-->
  <!--              delivered for any reason beyond our reasonable control.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              All communications in relation to services provided under these-->
  <!--              Terms and Conditions will be in English.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              By accessing the Platform, you automatically sign up for-->
  <!--              notifications and alerts via e-mail. Anyone with access to your-->
  <!--              e-mail will be able to view these alerts.-->
  <!--            </li>-->
  <!--          </ol>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          Your information-->
  <!--          <ol>-->
  <!--            <li>-->
  <!--              We may be required to verify your identity in accordance with-->
  <!--              applicable laws and regulations. For this reason, we may use your-->
  <!--              personal data, as that phrase is defined in the Personal Data-->
  <!--              Protection Act 2012 (&ldquo;Personal Information&rdquo;), in order-->
  <!--              to carry out electronic searches on private and public databases.-->
  <!--              We will keep records of any information obtained.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              In order to provide the Services (as defined at Clause 6.2) to you-->
  <!--              and/or to the Organisation for which you are an Authorised Person,-->
  <!--              we will need to collect, use, share and store any of your data or-->
  <!--              Personal Information and/or any data and information about the-->
  <!--              Organisation, which includes information about the-->
  <!--              Organisation&rsquo;s investments.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You authorise us to use any of your Personal Information and/or-->
  <!--              the data and information about the Organisation for which you are-->
  <!--              an Authorised Person which is relevant to the provision of our-->
  <!--              Services (as defined at Clause 6.2) to you and/or to the-->
  <!--              Organisation for all reasonable purposes in relation to the-->
  <!--              Services, which include without limitation to perform the-->
  <!--              following activities:-->
  <!--              <ol>-->
  <!--                <li>-->
  <!--                  collecting, storing, processing, using and disclosing such-->
  <!--                  Personal Information and/or data and information about the-->
  <!--                  Organisation for the following purposes:-->
  <!--                  <ol>-->
  <!--                    <li>-->
  <!--                      managing all aspects of the Services provided by us,-->
  <!--                      including due diligence, advisory, generating reports and-->
  <!--                      general administrative processes;-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      complying with applicable laws, regulations, rules and-->
  <!--                      orders, and the applicable code of conduct, policies and-->
  <!--                      procedures, or any other regulations applicable to us as-->
  <!--                      may be prevailing from time to time; and-->
  <!--                    </li>-->
  <!--                  </ol>-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  making such Personal Information and/or data and information-->
  <!--                  about the Organisation available or disclosing such Personal-->
  <!--                  Information and/or data and information about the Organisation-->
  <!--                  (including where the Personal Information and/or data and-->
  <!--                  information about the Organisation is transferred from-->
  <!--                  Singapore to any other country) to those who provide products-->
  <!--                  or services to us (such as financial institutions and-->
  <!--                  fiduciary service providers), regulatory authorities,-->
  <!--                  governmental or quasi-governmental organisations and of our-->
  <!--                  potential purchasers or any part of our business;-->
  <!--                </li>-->
  <!--              </ol>-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              We may retain and continue to process your Personal Information-->
  <!--              and/or data and information about the Organisation after the-->
  <!--              termination of these Terms and Conditions or any other agreement-->
  <!--              between you and us. Your Personal Information and/or the data and-->
  <!--              information about the Organisation may be transferred or disclosed-->
  <!--              to and/or by third parties where necessary, as stated above. This-->
  <!--              enables us to provide Services to you and to discharge our-->
  <!--              obligations to third parties, including relevant stock exchanges,-->
  <!--              government agencies and regulators. Your Personal Information-->
  <!--              and/or the data and information about the Organisation may be-->
  <!--              transferred outside of Singapore.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              With your consent, your Personal Information and/or the data and-->
  <!--              information about the Organisation may be used by us in order to-->
  <!--              provide you with information and marketing materials in relation-->
  <!--              to our other products and services. By entering into these Terms-->
  <!--              and Conditions you confirm your wish for your personal information-->
  <!--              to be processed for these additional purposes.-->
  <!--            </li>-->
  <!--          </ol>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          Your Undertakings and Warranties-->
  <!--          <ol>-->
  <!--            <li>-->
  <!--              You agree that the information provided by you in relation to the-->
  <!--              AI Request or the Digital FNA is done so in your capacity as an-->
  <!--              Authorised Person for and on behalf of the Organisation, where-->
  <!--              that Organisation is an existing customer with OCBC Bank, and that-->
  <!--              the information provided by you in relation to the AI Request or-->
  <!--              the Digital FNA is complete and accurate in all respects.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You warrant and represent in your capacity as an Authorised Person-->
  <!--              that any funds and monies held by the Organisation for which you-->
  <!--              are acting for and on behalf of in relation to the AI Request or-->
  <!--              the Digital FNA are from legitimate sources in connection with the-->
  <!--              Organisation&rsquo;s regular business activities (as the case may-->
  <!--              be) and which do not constitute the benefits of criminal conduct-->
  <!--              within the meaning of the Corruption, Drug Trafficking and Other-->
  <!--              Serious Crimes (Confiscation of Benefits) Act (Cap 65A).-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You acknowledge that due to anti-money laundering checks and our-->
  <!--              internal policies, we may require further information from you in-->
  <!--              your capacity as an Authorised Person and/or from the Organisation-->
  <!--              for which you are acting for and on behalf of before the AI-->
  <!--              Request or the Digital FNA can be processed and reviewed, and we-->
  <!--              shall be held harmless and indemnified against any loss arising as-->
  <!--              a result of a failure to process the AI Request or the Digital FNA-->
  <!--              if such information has been requested by us and has not been-->
  <!--              provided by you.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You confirm that your name does not and has not at any time-->
  <!--              appeared on the "watch lists" published by the United Nations as-->
  <!--              persons who are linked to terrorist activities or "watch lists" as-->
  <!--              required under the Terrorism (Suppression of Financing) Act ( Cap.-->
  <!--              325) pursuant to which dealings with persons specified therein are-->
  <!--              prohibited, restricted or discouraged.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You represent and warrant that you are not a politically exposed-->
  <!--              person or those persons or entities that are included on the List-->
  <!--              of Specially Designated Nationals and Blocked Persons maintained-->
  <!--              by the US Treasury Department's Office of Foreign Assets Control-->
  <!--              ("OFAC").-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You warrant that you are able to provide information and act as an-->
  <!--              Authorised Person for and behalf of the Organisation for which you-->
  <!--              are doing so without violating any applicable laws.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You confirm that in the case of delay or failure to provide-->
  <!--              satisfactory information, we may take such action (including-->
  <!--              declining to process and/or review the AI Request or the Digital-->
  <!--              FNA) as we think fit.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You undertake to inform us immediately if any of the-->
  <!--              representations, warranties, undertakings and/or confirmations or-->
  <!--              any other matter stated in these Terms and Conditions changes or-->
  <!--              is no longer accurate and complete in all respects.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You acknowledge and agree that insofar as reports, statements or-->
  <!--              other information are provided by the us electronically,-->
  <!--              electronic transmissions are not always secure and cannot be-->
  <!--              guaranteed to be error free as they can be intercepted, amended,-->
  <!--              lost or destroyed, or contain viruses. You accept these risks-->
  <!--              accordingly and agree that none of us, including our respective-->
  <!--              affiliates, directors, members, partners, shareholders, officers,-->
  <!--              employees and agents, shall be liable and each of the foregoing-->
  <!--              shall be held harmless for any losses, costs, damages, claims,-->
  <!--              demands and expenses whatsoever which you and/or the Organisation-->
  <!--              for which you are acting for and on behalf of as an Authorised-->
  <!--              Person may incur or sustain.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              As you are a natural person acting as an Authorised Person for and-->
  <!--              on behalf of the Organisation, you warrant and covenant with us-->
  <!--              that:-->
  <!--              <ol>-->
  <!--                <li>-->
  <!--                  you are of full legal age and have the legal capacity to act-->
  <!--                  as an Authorised Person to complete, digitally sign and submit-->
  <!--                  online the AI Request or the Digital FNA and to act in-->
  <!--                  accordance with these Terms andConditions;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  you, and/or the Organisation for which you are acting for and-->
  <!--                  on behalf of as an Authorised Person, are not a bankrupt or-->
  <!--                  otherwise financially insolvent;-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  no steps have been taken or are being taken to appoint a-->
  <!--                  receiver and/or official assignee or liquidator over or in-->
  <!--                  relation to you, and/or the Organisation for which you are-->
  <!--                  acting for and on behalf of as an Authorised Person, or the-->
  <!--                  assets held you and/or the Organisation, with a view to making-->
  <!--                  you and/or the Organisation bankrupt; and-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  where there is more than one person acting for and on behalf-->
  <!--                  of the Organisation in the capacity of an Authorised Person,-->
  <!--                  each and every person who as an Authorised Person individually-->
  <!--                  warrants and undertakes to us in addition to the warranties-->
  <!--                  and undertakings set out above that:-->
  <!--                  <ol>-->
  <!--                    <li>-->
  <!--                      each person's liability pursuant to the application of-->
  <!--                      these Term and Conditions shall be joint and several, and-->
  <!--                      any such person shall have full authority to give any-->
  <!--                      instructions and carry out any other actions pursuant to-->
  <!--                      the application of these Terms and Conditions and to-->
  <!--                      receive any demands, notices, statements, payments and-->
  <!--                      other communications for and on behalf of all such-->
  <!--                      persons.-->
  <!--                    </li>-->
  <!--                  </ol>-->
  <!--                </li>-->
  <!--              </ol>-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              If any of the foregoing representations, warranties or covenants-->
  <!--              ceases to be true or if we no longer reasonably believe that we-->
  <!--              has satisfactory evidence as to their truth, notwithstanding any-->
  <!--              other agreement to the contrary, we may be obligated to cease-->
  <!--              processing and/or reviewing the AI Request or the Digital FNA, and-->
  <!--              we may also be required to report such action and to disclose your-->
  <!--              identity and the Organisation for which you are acting for and on-->
  <!--              behalf of an Authorised Person, to the authority. In the event-->
  <!--              that we are required to take any of the foregoing actions, you-->
  <!--              understand and agree that you shall have no claim against us or-->
  <!--              any licensed banks/custodians/brokers or any other service-->
  <!--              providers which we use to provide the services to you, and their-->
  <!--              respective affiliates, directors, members, partners, shareholders,-->
  <!--              officers, employees and agents for any form of damages as a result-->
  <!--              of any of the aforementioned actions.-->
  <!--            </li>-->
  <!--          </ol>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          Our Services-->
  <!--          <ol>-->
  <!--            <li>-->
  <!--              The Services that we will provide under these Terms and Conditions-->
  <!--              are only available to those Organisations which are existing-->
  <!--              customers with OCBC Bank, and which have already been on-boarded.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              We will provide you and/or the Organisation with the following-->
  <!--              services under these Term and Conditions:-->
  <!--              <ol>-->
  <!--                <li>-->
  <!--                  the collection, processing and review of the information-->
  <!--                  completed and submitted in the AI Request or the Digital FNA-->
  <!--                  online to us by you in your capacity as an Authorised Person;-->
  <!--                  and-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  advice and/or recommendations for the Organisation for which-->
  <!--                  you are acting for and on behalf of as an Authorised Person-->
  <!--                  based on the Organisation Information (as defined at Clause-->
  <!--                  7.1) completed and submitted to us in the AI Request or the-->
  <!--                  Digital FNA.-->

  <!--                  <p>-->
  <!--                    (collectively referred to as &ldquo;the Services&rdquo;).-->
  <!--                  </p>-->
  <!--                </li>-->
  <!--              </ol>-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You, as an Authorised Person, shall be responsible for procuring-->
  <!--              the relevant tax and legal advice in relation to the Services-->
  <!--              provided, and we will not be responsible for the provision of the-->
  <!--              same. You shall ensure that throughout the usage of the Platform,-->
  <!--              there is a valid OCBC account for funds held in the name of the-->
  <!--              Organisation for which you are acting for and on behalf of as an-->
  <!--              Authorised Person.-->
  <!--            </li>-->
  <!--          </ol>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          Advice and Recommendations-->
  <!--          <ol>-->
  <!--            <li>-->
  <!--              The information completed and submitted in the AI Request or the-->
  <!--              Digital FNA by you as an Authorised Person comprises information-->
  <!--              about the Organisation for which you are acting for and on behalf-->
  <!--              of, including but not limited to information about the-->
  <!--              Organisation&rsquo;s current financial situation, investment-->
  <!--              history, current investment portfolio, risk profile and tolerance,-->
  <!--              investment priorities and objectives, and investment knowledge and-->
  <!--              experience (&ldquo;Organisation Information&rdquo;).-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              We will offer advice and recommendations to the Organisation for-->
  <!--              which you are acting for and on behalf of based on the-->
  <!--              Organisation Information that you complete and submit online in-->
  <!--              the AI Request or the Digital FNA. The advice and recommendations-->
  <!--              will be offered through an in-person adviser and/or on an-->
  <!--              automated a non-discretionary basis based on the Organisation-->
  <!--              Information provided in the AI Request or the Digital FNA. We will-->
  <!--              take all reasonable steps to provide the automated advice and-->
  <!--              recommendations with due care and skill.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              By completing and/or submitting the AI Request or the Digital FNA-->
  <!--              to us in your capacity as an Authorised Person acting for and on-->
  <!--              behalf of the Organisation you hereby acknowledge the nature and-->
  <!--              risks of acting on any advice and/or recommendations provided by-->
  <!--              us through in-person advisers and/or via automated advice. Please-->
  <!--              note that we are unable to provide any guarantee as to the outcome-->
  <!--              and/or performance of any advices and/or recommendations provided.-->
  <!--            </li>-->
  <!--          </ol>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          Liability-->
  <!--          <ol>-->
  <!--            <li>-->
  <!--              You agree that we and any of our respective subsidiaries and-->
  <!--              affiliates, directors, officers, agents, contractors, partners and-->
  <!--              employees will not in any way be liable for any losses, expenses-->
  <!--              or damages incurred by you as a result of or arising out of, or in-->
  <!--              connection with the Services provided under these Terms and-->
  <!--              Conditions, except those that arise due to our wilful default or-->
  <!--              fraud.-->
  <!--            </li>-->
  <!--          </ol>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          Indemnity-->
  <!--          <ol>-->
  <!--            <li>-->
  <!--              You agree to indemnify and keep indemnified us and any of our-->
  <!--              respective subsidiaries and affiliates, directors, members,-->
  <!--              partners, shareholders, officers, employees and agents against any-->
  <!--              and all losses, liabilities, damages, penalties, costs, fees and-->
  <!--              expenses (including legal fees and disbursements) which may-->
  <!--              result, directly or indirectly, from any inaccuracy in or breach-->
  <!--              of any representation, warranty, covenant or confirmation by you-->
  <!--              in these Terms and Conditions and/or from your failure to disclose-->
  <!--              any relevant details or provide us all information requested by-->
  <!--              any of us and/or arising out of or in connection with any breach-->
  <!--              of these Terms and Conditions.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You agree to indemnify us and our respective subsidiaries and-->
  <!--              affiliates, directors, members, partners, shareholders, officers,-->
  <!--              employees and agents and agree to keep each of these parties-->
  <!--              indemnified against any loss of any nature whatsoever arising to-->
  <!--              these parties as a result of any of these parties acting upon-->
  <!--              instructions through the Platform, website or e-mail instructions-->
  <!--              from you. We shall not be responsible for any missed delivery or-->
  <!--              non-receipt of any e-mail or courier or instructions through the-->
  <!--              Platform or website if we have not acknowledged receipt of the-->
  <!--              instruction through the Platform, website or e-mail or original-->
  <!--              document. E-mails or instructions through the Platform or website-->
  <!--              shall only be effective when acknowledged by written confirmation-->
  <!--              by us. In the event that no acknowledgement is received from us-->
  <!--              within fourteen (14) working days of submission of the request,-->
  <!--              you should contact your assigned Corporate Sales and Structurer to-->
  <!--              confirm receipt.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              The indemnities in this Clause 9 continue after the termination of-->
  <!--              your Account.-->
  <!--            </li>-->
  <!--          </ol>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          Termination-->
  <!--          <ol>-->
  <!--            <li>-->
  <!--              We may terminate or suspend your access to the Platform, in our-->
  <!--              sole discretion, at any time for any reason without notice to you.-->
  <!--              Further, if we believe, in our sole discretion, that a violation-->
  <!--              of these Terms and Conditions has occurred, we may take any other-->
  <!--              corrective action we deem appropriate. We reserve the right to-->
  <!--              investigate suspected violations of these Terms and Conditions. We-->
  <!--              may seek to gather information from any user who is suspected of-->
  <!--              violating these Terms and Conditions (or from any other user) and-->
  <!--              you agree to provide us with such information. We will fully-->
  <!--              cooperate with any law enforcement authorities or court order-->
  <!--              requesting or directing us to disclose the identity of anyone-->
  <!--              posting, publishing, or otherwise making available any user-->
  <!--              information, e-mails, or other materials that are believed to-->
  <!--              violate these Terms and Conditions.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              Any suspension, termination, or cancellation shall not affect your-->
  <!--              obligations in relation to the Platform under these Terms and-->
  <!--              Conditions (including but not limited to ownership,-->
  <!--              indemnification, and limitation of liability), which are intended-->
  <!--              to survive such suspension, termination, or cancellation. Any-->
  <!--              suspension, termination, or cancellation shall not affect the-->
  <!--              validity or enforceability of any other applicable agreements,-->
  <!--              disclosures, and documents that you are then currently a party to.-->
  <!--            </li>-->
  <!--          </ol>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          Consequence upon Termination-->
  <!--          <ol>-->
  <!--            <li>-->
  <!--              If we terminate your access to the Platform in our sole-->
  <!--              discretion, we may:-->
  <!--              <ol>-->
  <!--                <li>-->
  <!--                  take any action that a reasonably prudent person would be-->
  <!--                  expected to take; and-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  exercise any other power or right which we may have under-->
  <!--                  these Terms and Conditions or in law or equity.-->
  <!--                </li>-->
  <!--              </ol>-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              The termination of your access to the Platform does not affect-->
  <!--              any:-->
  <!--              <ol>-->
  <!--                <li>-->
  <!--                  claim by us in respect of accrued fees and expenses incurred;-->
  <!--                  and/or-->
  <!--                </li>-->
  <!--                <li>-->
  <!--                  other claim which either party may have against the other.-->
  <!--                </li>-->
  <!--              </ol>-->
  <!--            </li>-->
  <!--          </ol>-->
  <!--        </li>-->
  <!--        <li>-->
  <!--          Additional Provisions-->
  <!--          <ol>-->
  <!--            <li>-->
  <!--              These Terms and Conditions shall be read in conjunction with the-->
  <!--              Terms and Conditions Governing Electronic Banking Services-->
  <!--              (available at-->
  <!--              <a href="https://www.ocbc.com" target="_blank">www.ocbc.com</a>)-->
  <!--              and shall contain the entire agreement between you acting as an-->
  <!--              Authorised Person, the Organisation for which you are acting for-->
  <!--              and on behalf of, and us, in relation to the AI Request or the-->
  <!--              Digital FNA and the subject matter of these Term and Conditions.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              No failure on our part to exercise, and no delay on our part in-->
  <!--              exercising, any right or remedy under these Terms and Conditions-->
  <!--              or by law will operate as a waiver thereof, nor will any single or-->
  <!--              partial exercise of any right or remedy preclude any other or-->
  <!--              further exercise thereof or the exercise of any other right or-->
  <!--              remedy. No waiver shall be effective unless made in writing and-->
  <!--              executed by us waiving its right or remedy. The rights provided in-->
  <!--              these Terms and Conditions are cumulative and are not exclusive of-->
  <!--              any rights or remedies provided by law.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              If we are unable to carry out the whole or any part of its-->
  <!--              obligations under these Terms and Conditions for any reason beyond-->
  <!--              our control, including acts of God, war, riot and any other causes-->
  <!--              of such nature, then the performance of the obligations hereunder-->
  <!--              by us, insofar as they are affected by such cause, shall be-->
  <!--              excused during the continuance of any inability so caused, but-->
  <!--              such inability shall as far as possible be remedied with all-->
  <!--              reasonable dispatch.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              If any provision of these Term and Conditions shall be, or be-->
  <!--              found by any authority or court of competent jurisdiction to be,-->
  <!--              invalid or unenforceable (wholly or partly), such invalidity or-->
  <!--              unenforceability shall not affect the other provisions of these-->
  <!--              Terms and Conditions, all of which shall remain in full force and-->
  <!--              effect.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              You agree that you shall in your capacity as an Authorised Person-->
  <!--              acting for and on behalf of the Organisation do all such acts and-->
  <!--              things and execute and sign all such documents and instruments as-->
  <!--              may be necessary, desirable or expedient to give effect to the-->
  <!--              terms of, and the commercial understanding of these Terms and-->
  <!--              Conditions and the documents in connection herewith.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              The provisions of these Terms and Conditions are personal to you-->
  <!--              as an Authorised Person acting for and on behalf of the-->
  <!--              Organisation and you shall not be entitled to assign or transfer-->
  <!--              any of your rights or obligations under these Terms and-->
  <!--              Conditions.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              We, and our successors and assigns, may assign any or all of our-->
  <!--              respective rights and obligations under these Terms and-->
  <!--              Conditions. Any of our group company, and their successors and-->
  <!--              assigns, which has rights or benefits under these Terms and-->
  <!--              Conditions may assign any or all of their respective rights and-->
  <!--              obligations under these Terms and Conditions.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              The records kept by us in the Platform and/or website shall be-->
  <!--              conclusive of the facts and matters they purport to record except-->
  <!--              where there is an obvious mistake.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              These Terms and Conditions shall be governed by Singapore law. The-->
  <!--              parties agree to the non-exclusive jurisdiction of the courts of-->
  <!--              Singapore for all disputes in relation to these Terms and-->
  <!--              Conditions.-->
  <!--            </li>-->
  <!--            <li>-->
  <!--              The Contracts (Rights of Third Parties) Act (Cap. 53B) will not-->
  <!--              under any circumstances apply to these Terms and Conditions and-->
  <!--              any person who is not a party to these Terms and Conditions will-->
  <!--              have no right whatsoever under the Contracts (Rights of Third-->
  <!--              Parties) Act (Cap. 53B) to enforce these Terms and Conditions or-->
  <!--              any of its terms.-->
  <!--            </li>-->
  <!--          </ol>-->
  <!--        </li>-->
  <!--      </ol>-->
  <!--    </div>-->
  <!--  </div>-->

  <div class="modal-footer scroll-shadow-bottom modal-footer-button">
    <app-primary-button
      [outline]="true"
      (click)="handleRejectTermsAndConditions()"
      >Reject</app-primary-button
    >
    <app-primary-button (click)="handleAcceptTermsAndConditions()"
      >Accept</app-primary-button
    >
  </div>
</ng-template>
